import * as React from "react";
const SvgFiRrChatbotSpeechBubble = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-chatbot-speech-bubble_svg__a)">
      <path
        fill="#062147"
        d="M22.5 9H22V8c0-2.757-2.243-5-5-5h-4V1a1 1 0 1 0-2 0v2H7C4.243 3 2 5.243 2 8v1h-.5C.673 9 0 9.673 0 10.5v3c0 .827.673 1.5 1.5 1.5H2v1c0 2.757 2.243 5 5 5h7.697l3.963 2.642a2.15 2.15 0 0 0 2.206.106A2.15 2.15 0 0 0 22 21.854v-6.855h.5c.827 0 1.5-.673 1.5-1.5v-3c0-.827-.673-1.5-1.5-1.5zM20 21.855c0 .022 0 .089-.078.13-.08.043-.136.004-.152-.007l-4.215-2.81A1 1 0 0 0 15 19H7c-1.654 0-3-1.346-3-3V8c0-1.654 1.346-3 3-3h10c1.654 0 3 1.346 3 3zM7 9.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 7 9.5m10 0a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 17 9.5m-.153 4.695a1 1 0 0 1-.315 1.378C15.495 16.224 13.866 17 12.001 17s-3.494-.776-4.531-1.427a1 1 0 0 1 1.063-1.694c.815.512 2.079 1.121 3.469 1.121s2.653-.609 3.469-1.121a1 1 0 0 1 1.378.316z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-chatbot-speech-bubble_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrChatbotSpeechBubble;
